export enum MasterDataStatusEnum {
  Active = 0,
  Blocked
}
